module.exports = __webpack_public_path__ + "img/no-template-img.4ebd4ca3.svg";